import React from 'react';

const TRP = () => {
  return <span className="trp-no-wrap">T. Rowe Price</span>;
};

export default TRP;
